import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'PICTeacher',
    label: 'PICTeacher',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
